import { faFileDownload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from '@orobix/orobix-fe-components'
import { useQuery } from '@tanstack/react-query'
import { format } from 'date-fns'
import { useTranslation } from 'react-i18next'

import { get } from '../../utils/api'
import { handleApiErrors } from '../../utils/apiErrors'

const useDownload = (productId: number) =>
  useQuery<void>(
    ['annotations', 'download', productId],
    () =>
      get<BlobPart>(
        `/datatransfer/export/?product_id=${productId}`,
        {
          responseType: 'blob',
          headers: { 'content-type': 'application/zip' },
        },
        true
      )
        .then((response) => {
          const link = document.createElement('a')
          const now = format(new Date(), 'yyyyMMdd-HHmmss')

          link.target = '_blank'
          link.download = `product-${productId}-annotations-${now}.zip`
          link.href = URL.createObjectURL(
            new Blob([response], { type: 'application/zip' })
          )
          link.click()
        })
        .catch(handleApiErrors),
    {
      enabled: false,
    }
  )

export const DownloadAnnotationsButton = ({
  productId,
  disabled,
  title,
}: {
  productId: number
  disabled: boolean
  title: string
}) => {
  const { t } = useTranslation()
  const { isFetching, refetch } = useDownload(productId)

  return (
    <Button
      label={t('Export annotations')}
      loading={isFetching}
      icon={<FontAwesomeIcon icon={faFileDownload} />}
      hideLabel
      title={title}
      onClick={(e) => {
        e.stopPropagation()
        refetch()
      }}
      disabled={disabled}
      buttonType="button"
      type="blank-default"
    />
  )
}
